import { z } from 'zod';
import { CloseReasonSchema } from '../../model';
import { BpfCloseReasonType } from '../../types';

export const FetchCloseReasonsResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    list: z.array(CloseReasonSchema),
  }),
});

export const CreateCloseReasonsResponseSchema = z.object({
  createCloseReasons: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entities: z.array(CloseReasonSchema),
  }),
});

export const CreateCloseReasonsVariablesSchema = z.object({
  input: z.object({
    flowId: z.string().uuid(),
    reasons: z
      .array(
        z.object({
          label: z.string(),
          isActive: z.boolean(),
          type: z.nativeEnum(BpfCloseReasonType),
        })
      )
      .min(1),
  }),
});

export const MutateCloseReasonsResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    entity: CloseReasonSchema,
    error: z.string().nullable(),
  }),
});

export const CreateCloseReasonVariablesSchema = z.object({
  input: z.object({
    flowId: z.string().uuid(),
    reason: z.object({
      label: z.string(),
      isActive: z.boolean(),
      type: z.nativeEnum(BpfCloseReasonType),
    }),
  }),
});

export const UpdateCloseReasonStatusVariablesSchema = z.object({
  id: z.string().uuid(),
  status: z.boolean(),
});

export const UpdateCloseReasonLabelVariablesSchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
});

export const DeleteCloseReasonVariablesSchema = z.object({
  id: z.string().uuid(),
});
